import { useState } from 'react';
import ITEM from './item';

export default function PREPARE_ROUNDUP_SCORECARD({ items, onItemsChange, isCompleted }) {
  const [adding, setAdding] = useState(false);
  const [name, setName] = useState('');
  const [aim, setAim] = useState(0);
  const update = items => onItemsChange(items)?.catch(() => {});
  const edit = (index, field, value) => {
    if (isCompleted || (field === 'name' && !value.trim())) return;
    update(items.map((item, i) => i === index ? { ...item, [field]: field === 'name' ? value.trim() : Number(value) || 0 } : item));
  };
  const add = event => {
    event.preventDefault();
    if (isCompleted || !name.trim()) return;
    update([...items, { name: name.trim(), aim: Number(aim) || 0, value: 0 }]);
    setAdding(false); setName(''); setAim(0);
  };
  return <div className="prepare-roundup__scorecard">
    <h2>Scorecard</h2>
    <table><thead><tr><th>Item</th><th>Aim</th><th></th></tr></thead><tbody>
      {items.length ? items.map((item, index) => <ITEM key={index} item={item} index={index} isCompleted={isCompleted}
        handleDeleteItem={() => update(items.filter((_, i) => i !== index))} handleNameBlur={(index, value) => edit(index, 'name', value)} handleAimBlur={(index, value) => edit(index, 'aim', value)} />)
        : <tr><td colSpan="3">No scorecard items yet.</td></tr>}
    </tbody></table>
    {!isCompleted && <button onClick={() => setAdding(true)}>Add item to scorecard</button>}
    {adding && <form onSubmit={add} className="roundup-add-form">
      <label htmlFor="new-scorecard-name">Item name</label><input id="new-scorecard-name" required value={name} onChange={event => setName(event.target.value)} />
      <label htmlFor="new-scorecard-aim">Aim</label><input id="new-scorecard-aim" type="number" min="0" required value={aim} onChange={event => setAim(event.target.value)} />
      <button type="submit">Add item</button><button type="button" onClick={() => setAdding(false)}>Cancel</button>
    </form>}
  </div>;
}
